import { render, staticRenderFns } from "./OutboxEdit.vue?vue&type=template&id=4dc7356f"
import script from "./OutboxEdit.vue?vue&type=script&lang=js"
export * from "./OutboxEdit.vue?vue&type=script&lang=js"
import style0 from "./OutboxEdit.vue?vue&type=style&index=0&id=4dc7356f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports